import { auth } from '../config/firebase';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  sendPasswordResetEmail,
  updatePassword,
  sendEmailVerification,
  signInWithCustomToken,
  signInWithPhoneNumber,
  EmailAuthProvider,
  reauthenticateWithCredential
} from 'firebase/auth';

export const registerUser = async (email, password) => {
  return await createUserWithEmailAndPassword(auth, email, password);
};

export const signInUser = async (email, password) => {
  return await signInWithEmailAndPassword(auth, email, password);
};

export const signInUserWithToken = async (token) => {
  return await signInWithCustomToken(auth, token).catch((error) => {
    console.log(error);
  });
};

export const signInUserWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  return await signInWithPopup(auth, provider);
};

export const signOutUser = async () => {
  return await auth.signOut();
};

//PasswordReset
export const resetUserPassword = async (email) => {
  return await sendPasswordResetEmail(auth, email);
};

//PasswordUpdate
export const updateUserPassword = async (password) => {
  return await updatePassword(auth.currentUser, password);
};

export const changeUserPassword = async (currentPassword, newPassword) => {
  if (!auth.currentUser) {
    throw new Error('No authenticated user');
  }

  const email = String(auth.currentUser.email || '').trim();
  if (!email) {
    throw new Error('Current user does not support password authentication');
  }

  const credential = EmailAuthProvider.credential(email, currentPassword);
  await reauthenticateWithCredential(auth.currentUser, credential);
  return await updatePassword(auth.currentUser, newPassword);
};

//Send Email Verification
export const sendUserEmailVerification = async () => {
  return await sendEmailVerification(auth.currentUser);
};

export const signInWithPhone = async (phoneNumber, appVerifier) => {
  return await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
};

export const signInCredential = async (credential) => {
  return await signInWithCustomToken(auth, credential);
};
